export const responseIndicators = {
  POSTPARTUM_DEPRESSION: 'PostpartumDepression',
};
